import { SVGProps } from 'react';
const SvgTextAlignJustify = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20 18H4M20 14H4M20 10H4M20 6H4"
    />
  </svg>
);
export default SvgTextAlignJustify;
